var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#2B43DA",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.6662V16H3.3338L13.1707 6.16752L9.83732 2.83412L0 12.6662ZM9.8366 5.66183L2 13.4949V14H2.50563L10.342 6.1672L9.8366 5.66183ZM10.7793 1.88693L14.1131 5.22073L15.74 3.59383C16.0867 3.24712 16.0867 2.6826 15.74 2.33588L13.6641 0.260036C13.3174 -0.0866787 12.7529 -0.0866787 12.4062 0.260036L10.7793 1.88693Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b0c20879a98a7da2122506a0b32a4036.svg";
export { ForwardRef as ReactComponent };